import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { Component } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
@Component({
  selector: 'app-column-filter-popup',
  templateUrl: './column-filter-popup.component.html',
  styleUrls: ['./column-filter-popup.component.scss']
})
export class ColumnFilterPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<ColumnFilterPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private requestFormService: RequestFormService
  ) { }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    this.dialogRef.close(this.data.columns);
  }
  clearAll(): void {
    this.data.columns.forEach((col: { fixed: any; visible: boolean; }) => {
      if (!col.fixed) {
        col.visible = false;
      }
    });
  }
}
